module.exports = "<h2 class=\"{{ structure['element_classes'] }}\">{{ model }}</h2>\n"